import { render, staticRenderFns } from "./FacturaCfdiRelacionado.vue?vue&type=template&id=4947d826&"
import script from "./FacturaCfdiRelacionado.vue?vue&type=script&lang=js&"
export * from "./FacturaCfdiRelacionado.vue?vue&type=script&lang=js&"
import style0 from "./FacturaCfdiRelacionado.vue?vue&type=style&index=0&id=4947d826&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports